let products_on_page = document.getElementById('product-grid');
let next_url = products_on_page.dataset.nextUrl;
let load_more_btn = document.getElementsByClassName('load-more_btn')[0];
let load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

async function getNextPage() {
  try {
    products_on_page = document.getElementById('product-grid');
    next_url = products_on_page.dataset.nextUrl;
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  let load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  let load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'block';
  let nextPage = await getNextPage();

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  load_more_spinner.style.display = 'none';

  const productgrid = nextPageDoc.getElementById('product-grid');
  const new_products = productgrid.getElementsByClassName('product-block');
  next_url = productgrid.dataset.nextUrl;
  products_on_page.dataset.nextUrl = next_url;
  if (productgrid.dataset.nextUrl) {
    load_more_btn.style.display = 'flex';
  }
  products_on_page = document.getElementById('product-grid');
  for (let i = 0; i < new_products.length; i++) {
    let single_product = new_products[i].cloneNode(true);
    products_on_page.appendChild(single_product);
  }
}

document.addEventListener('click', function(event) {
  if (event.target.matches('button.load-more_btn')) {
    event.preventDefault();
    loadMoreProducts();
  }
}, false);